import React from 'react'
import tw from "twin.macro";
import styled from "styled-components";
import {Link} from 'react-router-dom'

import {ReactComponent as StarIcon} from "feather-icons/dist/icons/star.svg";
import {ReactComponent as ReelIcon} from "../images/flximg/reel.svg";
import AdComponent from '../components/AdComponent.js'

const Content = tw.div`mt-1  `;
const TextInfo = tw.div`bg-yellow-50 mt-2 lg:mt-1 mx-2`;
const TitleReviewContainer = tw.div`flex flex-row justify-between items-center xsm:-mt-2 md:-mt-1 lg:mt-0`;
const Title = tw.h5`text-sm font-bold text-gray-800`;
const Rating = tw.span`ml-2 my-auto text-gray-800 text-sm font-bold`;
const Year = tw.div`  text-xs text-yellow-800`;
const TextGenre = tw.div`text-sm text-gray-800`;

const YearInfo = styled.div`
  ${tw`flex items-center sm:ml-4 mt-2 sm:mt-0`}
  svg {
    ${tw`w-5 h-5 text-yellow-500 fill-current`}
  }
`;

const RatingsInfo = styled.div`
  ${tw`flex items-center sm:ml-4 mt-2 sm:mt-0`}
  svg {
    ${tw`lg:w-5 lg:h-5 w-4 h-4 text-yellow-500 fill-current`}
  }
`;
const CardImage = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`lg:h-72 lg:w-48 md:h-80 md:w-64 h-56 w-40 bg-cover bg-center rounded`,
]);
const IconContainer = styled.div`
  ${tw`inline-block rounded-full w-6 h-6 -ml-1 mr-2  text-gray-100`}
  svg {
    ${tw`w-4 h-4`}
  }
`;

function MovieCard({movie}) {
  return (
    
      movie.map((item) => (
        <Link to={`/movie/${item.id}`}>
          <Content>
            <CardImage imageSrc={item.cover_url} >

            </CardImage>
            <TextInfo>

              <TitleReviewContainer>
                <Title>{item.title}</Title>
                {item.rating ? <RatingsInfo>
                  <StarIcon />
                  <Rating>{item.rating}</Rating>
                </RatingsInfo> : <text></text>}
              </TitleReviewContainer>

              <TitleReviewContainer>
                {item.genre ?
                  <TextGenre>{item.genre}</TextGenre>
                  : <text></text>}
                <YearInfo>
                  <Year>{item.release_date}</Year>
                </YearInfo>
              </TitleReviewContainer>

            </TextInfo>
          </Content>
        </Link>

      ))
    
  )
}

export default MovieCard